export default __webpack_public_path__ + "static/media/chopinwaltz.571af20c.mp3";